import BannerHome from "./components/Banner/BannerHome";
import BookingComponent from "../../components/Booking";
import Utilities from "./components/Utilities";
import SlideDestination from "./components/Slidedestination";
import ServiceHome from "./components/ServiceHome";
import MapHome from "./components/MapHome";
import CommunityMandala from "./components/CommunityMandala";
function Home() {
  return (
    <div
      className="homePage"
      style={{
        backgroundImage: `url('/images/bgr.png')`,
      }}
    >
      <BannerHome />
      <BookingComponent />
      <Utilities />
      <SlideDestination />
      <ServiceHome />
      <MapHome />
      <CommunityMandala />
    </div>
  );
}
export default Home;
